import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GetAnalysisApiResponse } from '../../upload-requests-api/upload-requests-api.service';
import { AlertLevelEnum } from '../../upload-requests-api/alert-level.enum';
import { Features } from '../../../../types/types';
import { DownloadUtilService } from '../../../../services/download-util.service';

@Component({
    selector: 'app-summary-tab-content',
    templateUrl: './summary-tab-content.component.html',
    styleUrls: ['./summary-tab-content.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SummaryTabContentComponent implements OnInit {
  @Input() analysisSummaryData!: GetAnalysisApiResponse;
  @Input() analysisComplete!: boolean;
  @Input() isAnalysisLoading!: BehaviorSubject<boolean>;
  @Input() sentForReviewCount: number | undefined;
  @Input() uploadTypeLabel!: string;
  @Input() areColumnsMapped = false;
  @Input() hasSelectedFile = false;
  @Input() featureFlags!: Features;
  @Input() isSendForReviewAllowed = false;
  @Input() baseApiUrl = '/aptitude';
  @Output() loadAnalysis = new EventEmitter();
  @Output() submitForReview = new EventEmitter();

  analysisLoading = false;
  downloading = false;
  alertLevels = AlertLevelEnum;

  constructor(private downloadService: DownloadUtilService) {}

  ngOnInit(): void {
    if (this.isAnalysisLoading != null) {
      this.isAnalysisLoading.subscribe((x) => {
        this.analysisLoading = x;
      });
      this.loadAnalysis.emit();
    }
  }

  sendForReview() {
    this.submitForReview.emit();
  }

  download() {
    if (this.analysisSummaryData) {
      this.downloading = true;
      this.downloadService
        .download(
          `${this.baseApiUrl}/api${this.analysisSummaryData.downloadUrl}`,
          'download.xlsx',
        )
        .subscribe(() => {
          this.downloading = false;
        });
    }
  }
}
